export enum FilterBackendNamesEnum {
  SEARCH_BY_NAME = 'name',
  AUDIENCES = 'audiences',
  PHASES = 'phases',
  STATUSES = 'statuses',
}
